import { AxiosRequestBuilder } from '../../../services/axiosRequestBuilder';
import { Event } from '../types/search.types';

export const eventService = {
  buscarEventos: async (
    eventUIds: string,
    signal?: AbortSignal
  ): Promise<Event[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl(`Workshop/GetEvents/${eventUIds}`)
      .setResponseType('json')
      .setSignal(signal)
      .send<Event[]>();

    return data;
  },
};
